import type { Key, Token } from 'path-to-regexp';
import {
  parse,
  regexpToFunction,
  tokensToFunction,
  tokensToRegexp,
} from 'path-to-regexp';

interface SimplePatternOptions {
  delimiter?: string;
  end?: boolean;
  strict?: boolean;
  encode?: (segment: string) => string;
}

class SimplePattern {
  private tokens: Token[];
  private regexp: RegExp;
  private keys: Key[];

  constructor(
    rawPattern: string,
    private readonly options: SimplePatternOptions = {},
  ) {
    this.tokens = parse(rawPattern, options);
    this.keys = [];
    this.regexp = tokensToRegexp(this.tokens, this.keys, options);
  }

  match(target: string): Record<string, string> | null {
    const matchFucntion = regexpToFunction<Record<string, string>>(
      this.regexp,
      this.keys,
    );
    const matched = matchFucntion(target);
    return matched ? matched.params : null;
  }

  format(data: Record<string, string>): string {
    const formatFunction = tokensToFunction(this.tokens, {
      validate: false,
      encode: this.options.encode,
    });
    return formatFunction(data);
  }
}

export default SimplePattern;
